import ResourceView from '@/mixins/ResourceView';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { deparam } from '@/lib/utils';
import WidgetType from '@/enums/WidgetType';
import WidgetStyle from '@/enums/WidgetStyle';
import { REVIEW_FILTER_PARAMS } from '@/constants/PARAMS';

export default {
  mixins: [ResourceView],
  data() {
    return {
      isLoadingReviews: true
    };
  },
  created() {
    this.windowService.addMessageHandler(this.handleMessage);
    const params = this.filterQuery(this.$route.query);
    this.resourceParams = {
      ...params
    };
  },
  mounted() {
    this.fetchResource(this.resourceParams);
  },
  computed: {
    ...mapState(['brandCode', 'api']),
    ...mapState('widget', ['widget']),
    ...mapState('window', ['windowService']),
    ...mapState('review', ['pagy', 'isDeletingReview']),
    ...mapGetters('review', ['reviews']),
    ...mapState('session', ['sessionParams']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('productMediaReviewSummary', ['isLoadingMediaReviewSummary']),
    isLoading() {
      return (
        this.isLoadingReviews ||
        (this.widget.show_media_summary && this.isLoadingMediaReviewSummary) ||
        this.isDeletingReview
      );
    },
    isRefreshable() {
      if (this.widget.widget_type === WidgetType.PRODUCTS) return false;

      if (
        [
          WidgetStyle.PHOTO_THUMBNAIL,
          WidgetStyle.PRODUCT_OPTIONS,
          WidgetStyle.KEYWORD
        ].includes(this.widget.widget_style)
      )
        return false;

      return true;
    },
    shouldCheckReviewWritableOnSignin() {
      return (
        this.widget.show_header_section && this.widget.use_review_write_button
      );
    }
  },
  methods: {
    ...mapActions('review', ['fetchReviews', 'fetchReviewWritableCheck']),
    ...mapActions('session', ['setSessionParams', 'fetchSession']),
    ...mapActions(['initApi']),
    ...mapActions('productScoreSummary', ['fetchProductScoreSummary']),
    ...mapActions('productMediaReviewSummary', [
      'fetchProductMediaReviewSummary'
    ]),
    ...mapMutations('review', ['SET_TOTAL_REVIEWS_COUNT', 'PREPEND_REVIEWS']),
    fetchResource(params) {
      this.isLoadingReviews = true;
      this.fetchReviews({
        params: { ...this.defaultResourceParams, ...params }
      }).finally(() => (this.isLoadingReviews = false));

      if (this.widget.show_media_summary) this.fetchProductMediaReviewSummary();
    },
    handleMessage(data) {
      switch (data.act) {
        case 'popstate':
          this.resourceParams = this.filterQuery(data.params);
          this.fetchResource(this.resourceParams);
          break;
        case 'signin':
          if (this.isRefreshable) {
            const query = decodeURIComponent(data.url).split('?')[1] || '';
            this.setSessionParams(deparam(query));
            this.initApi({
              brandCode: this.brandCode,
              sessionParams: this.sessionParams
            });
            this.fetchResource(deparam(query));
            if (this.reviewSettings.review_form_enabled) {
              this.fetchSession();
            } else {
              if (this.shouldCheckReviewWritableOnSignin) {
                this.fetchReviewWritableCheck();
              }
            }
          }
          break;
        case 'popup':
          if (data.popup_act === 'add_new_review_content') {
            if (this.widget.show_product_score)
              this.fetchProductScoreSummary({ fields: 'scores_map' });
            if (this.totalReviewsCount !== null)
              this.SET_TOTAL_REVIEWS_COUNT(this.totalReviewsCount + 1);
            this.api
              .showReview(data.review_id, this.defaultResourceParams)
              .then(({ data }) => {
                this.PREPEND_REVIEWS({
                  reviews: [data.review],
                  pagy: this.pagy
                });
              });
          }
          break;
        // case 'count_showing_widgets':
        //   lib.data.set(data.selector, data.count)
        //   app.products_reviews_state.set_elements_state()
      }
    },
    isPopupParam(param) {
      return (
        param.startsWith('cohort_item_id') ||
        REVIEW_FILTER_PARAMS.includes(param) ||
        param.startsWith('option_') ||
        param.startsWith('product_option_')
      );
    }
  }
};
